/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="app.common.services.module.ts" />
/// <reference path="../isimpleattributes.d.ts" />

module App.Common.Services {
	'use strict';

	export class ElementHelperService {

		private attributeNamePrefixRegex = /^((?:x|data)[\:\-_])/i;

		public normalizeAttributeName(name: string) {
			return _.camelCase(name.replace(this.attributeNamePrefixRegex, ''));
		}

		public getAttributes(el: angular.IAugmentedJQuery): ISimpleAttributes {

			var result: ISimpleAttributes = {
				$normalize: this.normalizeAttributeName,
				$attr: {}
			};

			if (!el || !el.length) {
				return result;
			}

			_.forEach(el.get(0).attributes,
			(attribute) => {
				result[result.$normalize(attribute.name)] = attribute.value;
				result.$attr[result.$normalize(attribute.name)] = attribute.name;
			});

			return result;

		}
	}

	angular
		.module('app.common.services')
		.service('app.common.services.elementHelperService', ElementHelperService);
}